import {Component, Injectable, TemplateRef, Type} from "@angular/core";

export enum EnvironmentType {
    Unknown = 0,
    Prod = 1,
    Beta = 2,
    Dev = 3
}

export const EnvironmentTypeNames: Record<EnvironmentType, string> = {
    [EnvironmentType.Unknown]: null,
    [EnvironmentType.Prod]: 'Production',
    [EnvironmentType.Beta]: 'Beta',
    [EnvironmentType.Dev]: 'Development',
};

export const EnvironmentTypeShortNames: Record<EnvironmentType, string> = {
    [EnvironmentType.Unknown]: null,
    [EnvironmentType.Prod]: 'Prod',
    [EnvironmentType.Beta]: 'Beta',
    [EnvironmentType.Dev]: 'Dev',
};

@Injectable()
export class EnvironmentService {
    
    public GetEnvironmentType(): EnvironmentType {
        if (window.location.host.indexOf('localhost') !== -1) {
            return EnvironmentType.Dev;
        }
        else if (window.location.host.indexOf('beta') !== -1) {
            return EnvironmentType.Beta;
        }
        else {
            return EnvironmentType.Prod;
        }
    }
}